import { StrictLocalizeFunction } from "@faire/web/common/localization";

export const DEPARTMENTS = (
  strictLocalize: StrictLocalizeFunction
): Record<
  string,
  {
    title: string;
    parentDepartment?: string;
  }
> => ({
  Accounting: {
    title: strictLocalize({
      defaultMessage: "Accounting",
      description: { text: "Name of a department" },
    }),
  },
  "Algorithms & Data": {
    title: strictLocalize({
      defaultMessage: "Algorithms & Data",
      description: { text: "Name of a department" },
    }),
  },
  "Business Operations": {
    title: strictLocalize({
      defaultMessage: "Business Operations",
      description: { text: "Name of a department" },
    }),
  },
  Corporate: {
    title: strictLocalize({
      defaultMessage: "Corporate",
      description: { text: "Name of a department" },
    }),
  },
  "Customer Support": {
    title: strictLocalize({
      defaultMessage: "Customer Support",
      description: { text: "Name of a department" },
    }),
  },
  "Customer Success": {
    title: strictLocalize({
      defaultMessage: "Customer Success",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Customer Support",
  },
  "Customer Support Management": {
    title: strictLocalize({
      defaultMessage: "Customer Support Management",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Customer Support",
  },
  Design: {
    title: strictLocalize({
      defaultMessage: "Design",
      description: { text: "Name of a department" },
    }),
  },
  Engineering: {
    title: strictLocalize({
      defaultMessage: "Engineering",
      description: { text: "Name of a department" },
    }),
  },
  Finance: {
    title: strictLocalize({
      defaultMessage: "Finance",
      description: { text: "Name of a department" },
    }),
  },
  Legal: {
    title: strictLocalize({
      defaultMessage: "Legal",
      description: { text: "Name of a department" },
    }),
  },
  Marketing: {
    title: strictLocalize({
      defaultMessage: "Marketing",
      description: { text: "Name of a department" },
    }),
  },
  "Marketplace Operations": {
    title: strictLocalize({
      defaultMessage: "Marketplace Operations",
      description: { text: "Name of a department" },
    }),
  },
  People: {
    title: strictLocalize({
      defaultMessage: "People",
      description: { text: "Name of a department" },
    }),
  },
  Product: {
    title: strictLocalize({
      defaultMessage: "Product",
      description: { text: "Name of a department" },
    }),
  },
  "Retail and Brand": {
    title: strictLocalize({
      defaultMessage: "Retail and Brand",
      description: { text: "Name of a department" },
    }),
  },
  Risk: {
    title: strictLocalize({
      defaultMessage: "Risk",
      description: { text: "Name of a department" },
    }),
  },
  Sales: {
    title: strictLocalize({
      defaultMessage: "Sales",
      description: { text: "Name of a department" },
    }),
  },
  "Brand Partnerships": {
    title: strictLocalize({
      defaultMessage: "Brand Partnerships",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Sales",
  },
  "Retail Sales": {
    title: strictLocalize({
      defaultMessage: "Retail Sales",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Sales",
  },
  "Retail Account Management": {
    title: strictLocalize({
      defaultMessage: "Retail Account Management",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Sales",
  },
  "Brand Success Management": {
    title: strictLocalize({
      defaultMessage: "Brand Success Management",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Sales",
  },
  "Sales Management": {
    title: strictLocalize({
      defaultMessage: "Sales Management",
      description: { text: "Name of a department" },
    }),
    parentDepartment: "Sales",
  },
  "Strategy & Analytics ": {
    title: strictLocalize({
      defaultMessage: "Strategy & Analytics",
      description: { text: "Name of a department" },
    }),
  },
  Talent: {
    title: strictLocalize({
      defaultMessage: "Talent",
      description: { text: "Name of a department" },
    }),
  },
});
